import Config from './../utils/Config';
import Debug from './../utils/Debug';

export default function CookieConsent(cookieConsentUrl) {
  if (!window.document.getElementById('cookie_consent_script')) {
    const script = document.createElement('script');
    script.src = cookieConsentUrl;
    script.id = 'cookie_consent_script';
    script.async = true;
    document.body.appendChild(script);
    window.OptanonWrapper = function OptanonWrapper() {};
    script.onload = () => {};
    window.OptanonWrapper = function OptanonWrapper() {};

    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    const setConsentStatus = () => {
      try {
        let optIn = window._O && window._O.getOptIn().split('');
        if (optIn[1] === '1') {
          Config.set('hasAnalyticsConsent', true);
        } else {
          Config.set('hasAnalyticsConsent', false);
        }
      } catch (e) {
        Debug.log('Exception in setConsentStatus: ');
        Debug.log(e);
      }
    };
    window.dataLayer.push({
      event: 'pb.onOptInGroups',
      groups: '2:1',
      callback: () => {
        setConsentStatus();
      },
    });
    window.dataLayer.push({
      event: 'pb.onOptInGroups',
      groups: '2:0',
      callback: () => {
        setConsentStatus();
      },
    });
    window.dataLayer.push({
      event: 'pb.onOptInGroups',
      groups: '2:-',
      callback: () => {
        setConsentStatus();
      },
    });
  }
}
